/* eslint-disable @typescript-eslint/no-explicit-any */
import { AspectRatio } from "@/components/ui/aspect-ratio";
import Image from "next/image";
import { cn } from "@/lib/utils";
import { PlaceholderImage } from "@/components/common/placeholder-image";

function getDynamicFontSize(name: string) {
  if (name.length > 20) {
    return "text-xl xl:text-2xl 2xl:text-4xl";
  } else if (name.length > 10) {
    return "text-3xl xl:text-4xl 2xl:text-5xl";
  } else {
    return "text-4xl xl:text-5xl 2xl:text-6xl";
  }
}

export default function Card(props: any) {
  const { isSelected, image_link, name, description, title, year } = props;

  if (isSelected)
    return (
      <div>
        <AspectRatio ratio={100 / 71} className={cn("pointer-events-none relative")}>
          {image_link ? (
            <div>
              <Image
                src={image_link}
                fill
                style={{
                  objectFit: "cover",
                }}
                alt={name}
                className="rounded-2xl lg:rounded-3xl"
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 40vw"
                priority={false}
              />
              <div className="absolute ltr:-right-[400px] ltr:2xl:-right-[500px] rtl:-left-[400px] rtl:2xl:-left-[520px]">
                <h1
                  className={`max-w-[470px] whitespace-normal break-words text-secondary ltr:font-playfair ltr:tracking-[-1.44px] ${getDynamicFontSize(name)}`}
                >
                  {name}
                </h1>
                <p className="mt-2 text-sm text-[#FFCC68] xl:mt-3 xl:text-base ltr:font-opensans">
                  {`${title} - ${year}`}
                </p>
                <p className="max-w-sm pt-4 text-[13px] leading-[18px] text-secondary/60 xl:text-sm xl:leading-[21px] 2xl:max-w-[480px] 2xl:pt-4 2xl:text-base 2xl:leading-[24px] ltr:font-opensans">
                  {description}
                </p>
              </div>
            </div>
          ) : (
            <PlaceholderImage />
          )}
        </AspectRatio>
      </div>
    );

  return (
    <AspectRatio ratio={100 / 71} className={cn("pointer-events-none relative")}>
      {image_link ? (
        <div className="relative h-full w-full overflow-hidden rounded-[16px] bg-[#663B84]">
          <Image
            src={image_link}
            fill
            alt={name}
            className="object-cover opacity-60 mix-blend-luminosity"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            priority={false}
          />
        </div>
      ) : (
        <PlaceholderImage />
      )}
    </AspectRatio>
  );
}
